import React from "react";
import AppointmentHistory from "./tabs/appointmenthistory";
import {
  calenderIcon,
  chatIcon,
  documentIcon,
  iCardIcon,
  paymentIcon,
} from "./svgs";
import PaymentHistory from "./tabs/pamenthistory";
import MessagePatient from "./tabs/messagepatient";
import ICard from "./tabs/iCard";
import Document from "./tabs/Document";
import { pcardShows } from "../../config/practice";

export default function PatientTabs({
  appointmenthistory,
  data,
  paymentshistory,
  isLoading,
  activeTab,
  setActiveTab,
}) {
  // Vertical rail: the selected item is a solid navy block, the rest are plain.
  const tabClasses = (tab) =>
    `flex flex-none items-center gap-3 whitespace-nowrap rounded-[12px] px-4 py-3 text-[15px] lg:w-full font-inter font-medium transition focus:outline-none ${
      activeTab === tab
        ? "bg-[#1d2951] text-white ring-2 ring-[#1d2951]/20 ring-offset-2 ring-offset-white"
        : "bg-transparent text-[#2c3357] hover:bg-[#EEF1F6]"
    }`;

  const countPill = (tab, n) =>
    n === undefined || n === null ? null : (
      <span
        className={`ml-auto min-w-[28px] rounded-full px-2 py-0.5 text-center text-[12px] font-bold ${
          activeTab === tab ? "bg-white text-[#1d2951]" : "bg-[#EEF1F6] text-[#5B6478]"
        }`}
      >
        {n}
      </span>
    );



  const handleSend = (text) => {
    // Replace with your API call
    console.log("Send message:", text);
  };

  return (
    <div className="flex w-full min-w-0 flex-col lg:min-h-0 lg:flex-row lg:items-stretch lg:overflow-hidden">
      {/* Top Header Bar */}
      {/* <div className="px-4 py-2 text-sm font-semibold text-gray-700 text-start border-b border-[#F1F5F9] bg-gradient-to-r from-[rgba(80,134,154,0.05)] to-[rgba(80,134,154,0.10)]">
        Patient Records
      </div> */}

      {/* Tab Headers */}
      {/* Tab Headers */}
      {/* A scrolling row of tabs under the strip below lg; the vertical rail
          from lg up. */}
      <div className="flex flex-none gap-1.5 overflow-x-auto border-b border-[#EDF1F7] bg-white px-[16px] py-[12px] lg:w-[260px] lg:flex-col lg:overflow-y-auto lg:overflow-x-visible lg:border-b-0 lg:border-r lg:px-[24px] lg:py-[48px] xl:w-[300px]">
        <button
          className={tabClasses("appointments")}
          onClick={() => setActiveTab("appointments")}
        >
          {calenderIcon} Appointments
          {countPill("appointments", appointmenthistory?.length)}
        </button>

        <button
          className={tabClasses("payments")}
          onClick={() => setActiveTab("payments")}
        >
          {paymentIcon} Payments
          {countPill("payments", paymentshistory?.length)}
        </button>
        {/* <button
          className={tabClasses("messagepatient")}
          onClick={() => setActiveTab("messagepatient")}
        >
          {chatIcon} Message Patient
        </button> */}
        {/* iCard / Document: gated per practice (7825: neither) */}
        {pcardShows("icard") && (
        <button
          className={tabClasses("icard")}
          onClick={() => setActiveTab("icard")}
        >
          {iCardIcon} iCard
        </button>
        )}
        {pcardShows("document") && (
        <button
          className={tabClasses("document")}
          onClick={() => setActiveTab("document")}
        >
          {documentIcon} Documents
        </button>
        )}
      </div>

      {/* Tab Content */}
      <div className="min-w-0 flex-1 px-[12px] py-[16px] sm:px-6 sm:py-6 lg:overflow-y-auto">
        {activeTab === "appointments" && (
          <div>
            <AppointmentHistory
             activeTab={'appointments'}
              data={data}
              appointmenthistory={appointmenthistory}
              isLoading={isLoading}
            />
          </div>
        )}
        {activeTab === "payments" && (
          <div>
            <PaymentHistory
              paymentshistory={paymentshistory}
              isLoading={isLoading}
                 ischartmodal={false}
            />
          </div>
        )}
        {activeTab === "messagepatient" && (
          <div>
            <MessagePatient
           
            data={data}
    
            />
          </div>
        )}
        {activeTab === "icard" && pcardShows("icard") && (
          <div>
            <ICard 
              data={data}
            activeTab={'icard'} />
          </div>
        )}
        {activeTab === "document" && pcardShows("document") && (
          <div>
            <Document
              data={data}
              activeTab={'document'}
              onUpload={() => console.log("Upload clicked")}
              onView={(row) => window.open(row.url, "_blank")}
              onDelete={(row) => console.log("Delete", row)}
            />
          </div>
        )}
      </div>
    </div>
  );
}
